import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { cpGetLineOASparkline } from '@/lib/api/controlPlaneClient'
import type { PulsePeriod } from '@/hooks/usePulseSparkline'
import { useAuthStore } from '@/lib/store/authStore'

export function useLineOASparkline(
  period: PulsePeriod,
  enabled: boolean = true
) {
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  return useQuery({
    queryKey: ['line-oa-sparkline', period, activeStorefrontKey],
    queryFn: () => cpGetLineOASparkline(period),
    staleTime: 10 * 60 * 1000, // 10 min — LINE insight data changes slowly
    gcTime: 30 * 60 * 1000,
    placeholderData: keepPreviousData,
    enabled,
  })
}
